<!-- <app-loader></app-loader> -->
<!-- <p></p>
<p></p>
<p></p>
<p></p>  
<button class="btn btn-danger" type="button" style="margin-top: 80px;" (click)="add()">cart</button>
<button class="btn btn-danger" type="button" style="margin-top: 80px;" (click)="addFilter()">filter</button> -->

<router-outlet></router-outlet>